import { Group, Stack, TextInput } from '@mantine/core';
import { useUpdateContact, type Contact } from '@/models/contacts';
import { FormSaveBar } from '@/components/FormSaveBar';
import { CollapsibleCard } from '@/components/CollapsibleCard';
import { useCardForm } from '@/lib/useCardForm';

type Values = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  whatsapp: string;
  telegram: string;
};

export function IdentityCard({ contact }: { contact: Contact }) {
  const update = useUpdateContact();
  const { form, dirty, saving, handleSubmit } = useCardForm<Values>({
    initialValues: {
      firstName: contact.firstName ?? '',
      lastName: contact.lastName ?? '',
      email: contact.email ?? '',
      phone: contact.phone ?? '',
      whatsapp: contact.whatsapp ?? '',
      telegram: contact.telegram ?? '',
    },
    save: (dirtyValues) =>
      update.mutateAsync({ id: contact.id, ...dirtyValues }),
    successMessage: 'Identity saved',
  });

  return (
    <CollapsibleCard title="Identity info">
      <form onSubmit={handleSubmit}>
        <Stack gap="xs">
          <Group grow gap="xs">
            <TextInput
              label="First name"
              size="xs"
              {...form.getInputProps('firstName')}
            />
            <TextInput
              label="Last name"
              size="xs"
              {...form.getInputProps('lastName')}
            />
          </Group>
          <Group grow gap="xs">
            <TextInput
              label="Email"
              size="xs"
              {...form.getInputProps('email')}
            />
            <TextInput
              label="Phone"
              size="xs"
              {...form.getInputProps('phone')}
            />
          </Group>
          <Group grow gap="xs">
            <TextInput
              label="WhatsApp"
              size="xs"
              {...form.getInputProps('whatsapp')}
            />
            <TextInput
              label="Telegram"
              size="xs"
              {...form.getInputProps('telegram')}
            />
          </Group>
          {dirty && <FormSaveBar saving={saving} onDiscard={form.reset} />}
        </Stack>
      </form>
    </CollapsibleCard>
  );
}
